export default __webpack_public_path__ + "static/media/ico_cart.69665e06.svg";